const SaveMultiplePrompt = (props) => {
	const exitPrompt = () => {
		props.setUploadedImages([]);
		props.uploadMulitpleRef.current.value = null;
	};

	return (
		<div className="fixed top-0 left-0 w-screen h-screen flex justify-center items-center bg-black/50 max-h-full z-50">
			<div className="bg-white p-4 flex flex-col items-center justify-center gap-3 m-2 rounded-lg ">
				<p className="font-bold text-2xl">Save these files? </p>
				<div className="flex flex-row flex-wrap gap-3 items-center justify-center max-h-[75vh] overflow-y-scroll bg-gray-100 border border-black">
					{props.uploadPreviews.map((value, index) => {
						const fileType = props.uploadedImages[index]?.type;

						if (fileType === "application/pdf") {
							return <embed key={index} src={value} type="application/pdf" className="h-[40vh] w-[100%] max-w-[500px] border" />;
						} else {
							return <img key={index} src={value} alt="upload preview" className="max-h-[40vh] w-auto" />;
						}
					})}
				</div>

				<div className="flex gap-3">
					{" "}
					<p className="bg-green-300 p-4 cursor-pointer" onClick={(e) => props.uploadImages(e)}>
						Upload All
					</p>
					<p className="bg-gray-300 p-4 cursor-pointer" onClick={() => exitPrompt()}>
						Cancel
					</p>
				</div>
			</div>
		</div>
	);
};

export default SaveMultiplePrompt;
